<template>
    <ImageItem
        v-if="imageSrc"
        class="preview-image"
        :image-src="imageSrc"
        :style="[
            imageSize
                ? { maxHeight: `${imageSize}px`, minHeight: `${imageSize}px` }
                : { maxHeight: '100px', minHeight: '100px' },
        ]"
        scaling="contain"
        background-color="transparent"
    />
    <div
        v-else
        class="default-preview-image-container"
        :style="[
            imageSize
                ? { height: `${imageSize}px`, minHeight: `${imageSize}px` }
                : { maxHeight: '100px', minHeight: '100px' },
        ]"
    >
        <i :class="fallbackIcon" class="fa-light fa-2x" />
    </div>
</template>

<script setup lang="ts">
import ImageItem from "@/shared/components/image-item/image-item.vue";

defineProps<{
    imageSrc: string | undefined;
    fallbackIcon: string;
    // override custom max height/width - use max-height of 100px only, when none is given
    imageSize?: number;
}>();
</script>

<style lang="scss" scoped>
.preview-image {
    display: flex;
    justify-content: center;
    background-color: $white;
    aspect-ratio: 4 / 3;
}
.default-preview-image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $icon-background-color;
    aspect-ratio: 4 / 3;

    i {
        color: $icon-color-light;
    }
}
</style>
